import React from 'react'
import { Typography } from '@material-ui/core'
import { useStepLoriStyles } from '../styles'

export const StepLoriWelcome: React.FC = () => {
    const classes = useStepLoriStyles()

    return (
        <div className={classes.welcomeCard}>
            <Typography variant="body2" className={classes.welcomeSubtitle}>
                Here is what to expect as we begin:
            </Typography>
            <ul className={classes.welcomeList}>
                <li className={classes.welcomeListItem}>
                    <Typography
                        variant="body2"
                        className={classes.welcomeDescription}
                    >
                        I will guide you step by step through the process of
                        scheduling your turn project.
                    </Typography>
                </li>

                <li className={classes.welcomeListItem}>
                    <Typography
                        variant="body2"
                        className={classes.welcomeDescription}
                    >
                        If you are not sure how to answer a question, please ask
                        for clarification.
                    </Typography>
                </li>
            </ul>
        </div>
    )
}
